module.exports = __webpack_public_path__ + "img/img-11-mobile.03de0914.webp";